const ancestorAxis = [
    {
        type: 'ancestorAxisJson',
        cacheKeys: [
            'dname',
            'id'
        ]
    }
];
export const test = {
    acl: 'g:admin,g:debug',
    parts: [
        {
            align: 'top',
            type: 'AdminHeader',
            acl: '-c:vlm'
        }
    ],
    tabs: {
        list: {
            default: true,
            parts: [
                'ListTestPages'
            ]
        },
        history: {
            parts: [
                {
                    type: 'ReleaseHistory',
                    name: 'ReleaseHistory',
                    limit: 30,
                    filters: [
                        {
                            limit: 30,
                            cacheKeys: [
                                'dname',
                                'cname',
                                'max',
                                'limit',
                                'withFacets'
                            ],
                            type: 'getReleaseHistory',
                            paramsFromPart: 'max, limit, withFacets'
                        }
                    ]
                }
            ]
        },
        titles: {
            parts: [
                {
                    type: 'AllDocuments',
                    name: 'AllDocuments',
                    limit: 30,
                    filters: [
                        'getAllDocuments'
                    ]
                }
            ]
        },
        states: {
            parts: [
                'TestStates'
            ]
        },
        test1: {
            parts: [
                {
                    type: 'TestDummy',
                    clickTarget: 'test2',
                    filters: [
                        {
                            ident: 'home',
                            type: 'getWikiRendered'
                        }
                    ]
                }
            ]
        },
        test2: {
            parts: [
                {
                    type: 'TestDummy',
                    clickTarget: 'test1',
                    filters: [
                        {
                            ident: 'imprint',
                            type: 'getWikiRendered'
                        }
                    ]
                }
            ]
        },
        uiprops: {
            parts: [
                'TestUIProps',
                'TestUIPropsDerived1',
                'TestUIPropsDerived2',
                'TestUIPropsDerived4',
                'TestUIPropsDerived5',
                'TestUIPropsFunctional',
                'TestUIPropsHooks',
                'TestUIPropsHooksRaw'
            ]
        },
        i18n: {
            parts: [
                'TestI18N'
            ]
        },
        domains: {
            parts: [
                'TestDomains'
            ]
        },
        tree: {
            parts: [
                {
                    type: 'TestTreeSync',
                    name: 'TreeLeft',
                    align: 'left'
                },
                {
                    type: 'TreeInfo',
                    align: 'center'
                }
            ],
            layout: 'L131Split',
            filters: ancestorAxis
        },
        editor: {
            parts: [
                'TestEditor'
            ]
        },
        differ: {
            parts: [
                'TestDiffer'
            ]
        },
        graphics: {
            parts: [
                'TestGraphics'
            ]
        },
        mordor: {
            parts: [
                {
                    type: 'ViewerGrid',
                    filters: [
                        'structuredImageLocationsJson'
                    ],
                    style: {
                        height: '80vh',
                        display: 'flex',
                        flexDirection: 'column'
                    }
                }
            ]
        },
        plots: {
            parts: [
                {
                    type: 'PlotLister',
                    flex: 1,
                    overflow: 'auto',
                    filters: [
                        'getPlotList'
                    ]
                }
            ]
        },
        mods: {
            datatype: [
                1
            ],
            parts: [
                {
                    type: 'ModsRenderer',
                    flex: 1,
                    overflow: 'auto',
                    filters: [
                        {
                            type: 'getModsData',
                            encoding: 'utf-8'
                        },
                        'getModsRendered',
                        'getModsRenderedAll'
                    ]
                }
            ]
        },
        wiki: {
            layout: 'L131Split',
            parts: [
                {
                    type: 'SimpleWikiList',
                    align: 'left',
                    filters: [
                        {
                            type: 'getWikiIdents'
                        }
                    ]
                },
                {
                    type: 'WikiEditor',
                    filters: [
                        {
                            type: 'getWikiCode',
                            identifier: 'wikisyntax'
                        }
                    ]
                }
            ]
        },
        interpreter: {
            parts: [
                {
                    type: 'SimpleInterpreter'
                }
            ]
        },
        navbox: {
            parts: [
                {
                    type: 'TestNavbox',
                    align: 'left',
                    filters: [
                        {
                            type: 'getNavboxData'
                        }
                    ]
                },
                {
                    type: 'Wikiblock',
                    name: 'WikiHome',
                    filters: [
                        {
                            ident: 'home!',
                            type: 'getWikiRendered'
                        }
                    ]
                }
            ]
        },
        splitters: {
            parts: [
                {
                    type: 'LoremIpsum',
                    align: 'left',
                    name: 'Lips1'
                },
                {
                    type: 'LoremIpsum',
                    align: 'center',
                    name: 'Lips2'
                },
                {
                    type: 'LoremIpsum',
                    align: 'right',
                    name: 'Lips3'
                }
            ],
            layout: 'L131Split'
        },
        blank: {
            parts: [
                {
                    type: 'LoremIpsum'
                }
            ],
            layout: 'blank'
        },
        errors: {
            parts: [
                {
                    type: 'LoremIpsum',
                    filters: [
                        {
                            type: 'raiseError'
                        }
                    ]
                },
                {
                    align: 'right',
                    type: 'TestErrorDuringRender'
                }
            ]
        },
        css: {
            parts: [
                'LoremIpsum',
                {
                    type: 'ThemeBuilder',
                    align: 'left'
                }
            ]
        },
        config: {
            parts: [
                {
                    type: 'EditConfig',
                    filters: [
                        {
                            type: 'getConfigAndChain'
                        },
                        {
                            type: 'getDatabaseConfigData'
                        }
                    ]
                }
            ]
        },
        auth: {
            parts: [
                'AuthLogin',
                'WebAuthN'
            ]
        },
        responsive: {
            parts: [
                {
                    type: 'LoremIpsum',
                    align: 'left',
                    style: 'width: 200px'
                },
                {
                    type: 'LoremIpsum',
                    align: 'center'
                }
            ],
            layout: 'Responsive'
        },
        jobs: {
            parts: [
                'JobSearch'
            ]
        },
        whiteboard: {
            layout: 'L131Split',
            parts: [
                'Whiteboard'
            ]
        },
        frontend: {
            parts: [
                'TestExplorer'
            ],
            filters: ancestorAxis
        },
        backend: {
            parts: [
                'TestExplorer'
            ],
            filters: ancestorAxis
        },
        parts: {
            parts: [
                'TestParts'
            ],
            filters: ancestorAxis
        },
        useApi: {
            parts: [
                'TestUseApi'
            ]
        },
        treeNodeLinks: {
            parts: [
                'TestTreeNodeLinks'
            ]
        },
        treeContextStats: {
            parts: [
                'TestTreeContextStats'
            ]
        },
        treeStats: {
            parts: [
                'TestTreeStats'
            ]
        },
        treePropEdit: {
            parts: [
                'TestTreePropEdit'
            ]
        },
        treeImportIdEdit: {
            parts: [
                'TestTreeImportIdEdit'
            ]
        },
        treePageUpload: {
            parts: [
                'TestTreePageUpload'
            ]
        },
        treeDeleteResources: {
            parts: [
                'TestTreeDeleteResources'
            ]
        },
        treeResort: {
            parts: [
                'TestTreeResort'
            ]
        },
        treeRevokeStructures: {
            parts: [
                'TestTreeRevokeStructures'
            ]
        },
        treePaginate: {
            parts: [
                'TestTreePaginate'
            ]
        },
        badJsonError: {
            parts: [
                'TestApiError'
            ]
        },
        plots: {
            parts: [
                'TestPlots'
            ]
        },
        chat: {
            layout: 'L131Split',
            parts: [
                'TestChat'
            ]
        },
        dbtable: {
            parts: [
                'TreeList'
            ],
            filters: ancestorAxis
        },
        hmr: {
            parts: [
                'HmrTestAsModule',
                'HmrTestInParts'
            ]
        }
    }
};
